import { deliveryChargeTypeName } from '@/constants/storeManagement/deliveryChargeDialog';
import { weekTypeList } from '@/constants/week';
/**
 * vuex store의 state에서 사용.
 * serviceData의 인자값 타입으로 사용.
 */
// eslint-disable-next-line import/prefer-default-export
export class FormDataDeliveryCharge {
    /** 배달대행료 아이디 */
    id = null;
    storeName = '';
    /** 도착지(지명) */
    specialArea = '';
    workingDay = [
        ...weekTypeList,
    ];
    /** 시작 시간 */
    businessHourStart = '00:00';
    /** 종료 시간 */
    businessHourEnd = '23:59';
    /** 대행료 */
    charge = '0';
    /** 할증배달대행료 */
    surcharge = '0';
    /** 구분 */
    type = deliveryChargeTypeName.DISTANCE;
    /** 거리 이상 */
    distanceStart = 0;
    /** 거리 미만 */
    distanceEnd = 0;
    /** 번지 이상 */
    addressJibunStart = 0;
    /** 번지 미만 */
    addressJibunEnd = 0;
    /** 구역 이름 */
    areaName = '';
    /** 구역 아이디 */
    areaId = null;
    constructor(data) {
        if (!data) {
            return;
        }
        Object.assign(this, data);
    }
}
